/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useMemo} from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import SectionCard from '../../../../../../../material/expandablesection/sectioncard/sectioncard';
import SentimentShowcase from './sentimentshowcase/sentimentshowcase';
// styles
import injectSheet from 'react-jss';
import styles from './colorpreview_styles';
import {TIME_RANGE_LIST} from "../../../../../../../state/slices/engagement";


/* ========== ~~~~~~~~~~ COLOR PREVIEW ~~~~~~~~~~ ========== */
const ColorPreview = injectSheet(styles)((props) => {
  const {
    config: {
      overviewTimeRange,
      colorConfiguration,
      title,
    }
  } = props;

  const timeRangeTitle = useMemo(() =>
    TIME_RANGE_LIST?.find(i => i.value === overviewTimeRange)?.title || ''
    ,[overviewTimeRange])

    return (
        <div className={`colorpreview ${props.classes.colorpreview}`}>
          <SectionCard>
            <div className={'previewcontainer'}>
              <SentimentShowcase
                {...colorConfiguration}
                title={title}
                counter={'1K reactions'}
                isOverview={false}
              />
              <SentimentShowcase
                {...colorConfiguration}
                title={`Overview for All Articles (${timeRangeTitle})`}
                counter={'2.3K Reactions'}
                isOverview={true}
              />
            </div>
          </SectionCard>
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ColorPreview;

